import { style } from "@vanilla-extract/css";

export const formStyle = style({
  textAlign: "left",
});
